<osp-dialog>
  <ng-template ospTemplate="content">
    <div class="pb-6">
      {{ 'shared.createEntity.entitySelection.title' | translate }}
    </div>
    <osp-card-option-list
      class="pb-6"
      [options]="assets"
      [ngModel]="$selectedType()"
      (ngModelChange)="$selectedType.set($event)"
    />
  </ng-template>

  <ng-template ospTemplate="footer">
    <div class="flex align-items-center justify-content-between">
      <osp-button
        [label]="'general.buttons.cancel' | translate"
        [icon]="IconKey.GlobalCancel | icon"
        [category]="'ghost'"
        (onClick)="onCancel()"
      />
      <osp-button
        [label]="'general.buttons.next' | translate"
        [icon]="IconKey.GlobalFormNext | icon"
        [disabled]="!$selectedType()"
        (onClick)="onNext()"
      />
    </div>
  </ng-template>
</osp-dialog>
